export default __webpack_public_path__ + "static/media/honywell.e9f27f89.jpg";